/*
  HTML malformado gerado pelo editor antigo em alguns comentários
  (padrão visto em campo: `<img src=" <a target=...>...` — onde o link
  inteiro foi concatenado dentro do valor do atributo `src`) faz o
  browser produzir um DOM inesperado via `dangerouslySetInnerHTML`,
  causando hydration mismatches e invariants de React que derrubavam a
  lista de comentários inteira.

  Essa sanitização:
   1. Detecta `<img>` cujo `src` contém `<` (sempre indica tag HTML
      incorretamente escapada — URLs válidas nunca contêm esse char);
   2. Substitui a imagem e o trecho lixo que normalmente vem colado
      (e.g.  `...<a>url<a/>`) por um placeholder visível;
   3. Roda igual em SSR e cliente (regex puro, sem DOM), então a
      hidratação é consistente.
*/

const INVALID_IMG_PLACEHOLDER =
  '<span class="text-neutral-low-300">[imagem inválida]</span>';

/*
  Regex geral: casa `<img ...src="..."` onde o valor do `src` tem um
  `<` antes da próxima aspa, e estende o casamento até o `>` de
  fechamento subsequente + qualquer tag `</a>` emendada logo depois
  (é o shape visto em campo — o `<a>` quebrado costuma sobrar
  pendurado no fim).
*/
const BROKEN_IMG_RE =
  /<img\b[^>]*\bsrc\s*=\s*(["'])[^"'<>]*<[\s\S]*?\1[^>]*>(?:[^<]*<\/a>)?/gi;

export const sanitizeCommentHtml = (html) => {
  if (typeof html !== 'string' || html.indexOf('<img') === -1) {
    return html;
  }

  return html.replace(BROKEN_IMG_RE, INVALID_IMG_PLACEHOLDER);
};
